
import './App.css';
import routes from './Router/router';

import { RouterProvider } from "react-router-dom";
import AuthProvider from './components/AuthProvider/AuthProvider';
function App() {
  return (
    <div className="">
      <AuthProvider>
        <RouterProvider router={routes} />
      </AuthProvider>



    </div>
  );
}

export default App;
